// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.formContainer_BHLCy {
  display: grid;
  gap: 24px;
  outline: none;
}

.addButton_n01EP {
  background-color: #208de6;
  color: var(--white-color);
  display: flex;
  justify-content: flex-start;
  gap: 24px;
  align-items: center;
  border-radius: 6px;
  border: none;
  height: 40px;
  padding: 8px;
  cursor: pointer;
  width: 100%;
}

.buttonText_VNYOH {
  border-left: 1px solid var(--white-color);
  height: 40px;
  display: flex;
  align-items: center;
  margin-left: -15px;
  padding-left: 22px;
}
`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/components/Automate/Components/ModalsAddConnection/FTPModalAddConnection.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,SAAS;EACT,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,aAAa;EACb,2BAA2B;EAC3B,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,WAAW;AACb;;AAEA;EACE,yCAAyC;EACzC,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB","sourcesContent":[".formContainer {\n  display: grid;\n  gap: 24px;\n  outline: none;\n}\n\n.addButton {\n  background-color: #208de6;\n  color: var(--white-color);\n  display: flex;\n  justify-content: flex-start;\n  gap: 24px;\n  align-items: center;\n  border-radius: 6px;\n  border: none;\n  height: 40px;\n  padding: 8px;\n  cursor: pointer;\n  width: 100%;\n}\n\n.buttonText {\n  border-left: 1px solid var(--white-color);\n  height: 40px;\n  display: flex;\n  align-items: center;\n  margin-left: -15px;\n  padding-left: 22px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"formContainer": `formContainer_BHLCy`,
	"addButton": `addButton_n01EP`,
	"buttonText": `buttonText_VNYOH`
};
export default ___CSS_LOADER_EXPORT___;
